export enum FilterView {
  all = "all",
  collaborating = "collaborating",
}

export const DEFAULT_FILTER = FilterView.all;
